import cuid from "cuid";
import { i18n } from "../main";
import { PERIOD } from "@/enums/period.enum";

export function filterOptions() {
  return [
    {
      id: cuid(),
      name: i18n.t("message.reviews.categories.filters.yesterday"),
      type: PERIOD.DAYS,
      quantity: 1
    },
    {
      id: cuid(),
      name: i18n.t("message.reviews.categories.filters.last7Days"),
      type: PERIOD.DAYS,
      quantity: 7
    },
    {
      id: cuid(),
      name: i18n.t("message.reviews.categories.filters.last30Days"),
      type: PERIOD.DAYS,
      quantity: 30
    },
    {
      id: cuid(),
      name: i18n.t("message.reviews.categories.filters.last90Days"),
      type: PERIOD.DAYS,
      quantity: 90
    },
    {
      id: cuid(),
      name: i18n.t("message.reviews.categories.filters.last180Days"),
      type: PERIOD.DAYS,
      quantity: 180
    },
    {
      id: cuid(),
      name: i18n.t("message.reviews.categories.filters.last365Days"),
      type: PERIOD.DAYS,
      quantity: 365
    },
    {
      id: cuid(),
      name: i18n.t("message.reviews.categories.filters.lastWeek"),
      type: PERIOD.WEEKS,
      quantity: 1
    },
    {
      id: cuid(),
      name: i18n.t("message.reviews.categories.filters.lastMonth"),
      type: PERIOD.MONTHS,
      quantity: 1
    },
    {
      id: cuid(),
      name: i18n.t("message.reviews.categories.filters.lastQuarter"),
      type: PERIOD.QUARTER,
      quantity: 1
    },
    {
      id: cuid(),
      name: i18n.t("message.reviews.categories.filters.last6Months"),
      type: PERIOD.MONTHS,
      quantity: 6
    },
    {
      id: cuid(),
      name: i18n.t("message.reviews.categories.filters.lastYear"),
      type: PERIOD.YEARS,
      quantity: 1
    },
    {
      id: cuid(),
      name: i18n.t("message.reviews.categories.filters.fromBeginning"),
      type: PERIOD.FULL,
      quantity: 0
    }
  ];
}

export function compareOptions() {
  return [
    {
      id: cuid(),
      name: i18n.t("message.reviews.categories.filters.previousTerm"),
      value: 1
    },
    {
      id: cuid(),
      name: i18n.t("message.reviews.categories.filters.previousYear"),
      value: 2
    }
  ];
}
